const Nuevamente = {
	palette: {
		type:"light",
		// common:{
		// 	black:"#ff0000",
		// 	white:"#ffff00"
		// },
		primary:{
			main:"#000000"//"#2991d6"
		},
		secondary:{
			main:"#fff"
		},
		background:{
			paper:"#fff",
			default:"#f7f7f7"
		},
		textColor: "#3B3C3C",
		primary1Color: "#1BB6B1",
		secondaryTextColor: "#757575",
		alternateTextColor: "#ffffff",
		disabledColor: "#70787D",	
	},
	typography:{
		h1:{ //Título del encabezado de la sección
			color:"white",
			fontSize:20,
			fontWeight:"400",
		},
		subtitle1:{ //Subtítulo del encabezado de la sección
			color:"white",
			fontSize:16,
		},
		h2:{ //Título del encabezado del paper
			fontSize:20,
			color:"#2a2a2a",
			// fontFamily:"Roboto-Regular"
		},
		h3:{
			fontSize:14,
			color:"#2a2a2a",
		},
		link:{
			fontSize:10,
			color:"#2a2a2a",
		},
		body1:{
			color:"rgb(0,0,0,0.87)",
			fontSize:13
		}
	},
	overrides:{
		MuiTableCell:{
			stickyHeader:{
				fontSize:12,
				color:"rgb(0,0,0,0.54)",
				backgroundColor:"#FFF"
			},
			body:{
				color:"rgb(0,0,0,0.87)",
				fontSize:13
			},
			root:{
				padding:8
			}
		},
		MuiTablePagination:{
			caption:{
				fontSize:12,
				color:"rgb(0,0,0,0.54)"
			},
			root:{
				fontSize:12,
				color:"rgb(0,0,0,0.54)"
			}
		},
		MuiMenuItem:{
			root:{
				fontSize:12,
				//color:"rgb(0,0,0,0.54)"
			}
		},
		MuiButton:{
			containedSecondary:{
				color:"#000000"//"#2991d6"
			}
		},
		MuiIconButton:{
			root:{
				padding:5
			}
		},
		MuiFormLabel:{
			root:{
				color:"rgba(0, 0, 0, 0.38)",
				fontSize:16,
				width:"max-content"
			}
		},
		MuiAutocomplete:{
			root:{
				width:"100%"
			}
		},
		MuiGrid:{
			item:{
				marginTop:12,
				marginBottom:12
			}
		},
		MuiContainer:{
			root:{
				height:"100%"
			}
		},
		MuiTabs:{
			indicator:{
				borderBottomColor:"#F96A02CC",
				borderBottomWidth:4,
				borderBottomStyle:"solid"
			}
		}
	},
	drawer:{
		header:{
			background:"linear-gradient(to right, #333333, #000000)"
		}
	},
	menuItem:{
		color:"rgba(103, 103, 103, 0.87)"
	},
	appBar: {
		root:{
			background: "linear-gradient(to bottom, #000, #444 85%)",//"linear-gradient(to bottom, #2275ac, #2991d6 85%)",
			position: "static",
			alignItems: "baseline",
			justifyContent: "center",
			height:49
		},
		toolbar:{
			paddingLeft:0
		},
		leftIcon: {
			color: "#fff",
			//marginLeft: 5,
			marginRight: 0,
			marginTop: 0
		}
	},
	logo:{
		height: 24
	},
	breadcrumb:{
		container:{
			//marginBottom: 10,
			paddingTop:9,
			paddingLeft:23,
			paddingBottom:7,
			fontSize: "0.8rem",
			width: "100%",
			position: "static",
			zIndex: 9
		},
		separator: {
			color: "#444"//"#1bb6b1"
		},
		text: {
			color:"#000"//"#0091d4"
		}
	},
	title:{
		container:{
			height:91,
			width:"100%",
			background: "#000",//"#5d9ac2",
			paddingLeft: 83,
			paddingTop:21,
			marginBottom:60
		},
		backIconContainer:{
			marginTop:-10,
		},
		backIcon:{
			color:"#fff",
		}
	},
	routesContainer:{
		height:"100%", 
		width:"100%",
		backgroundColor:"#f7f7f7"
	},
	mainContainer:{
		height:"89%",
		width:"100%",
		position:"absolute",
		top:80,
		left:0,
		bottom:0,
		right:0,
		overflow:"scroll",
	},
	paper:{
		title:{
			paddingTop:21,
			paddingBottom:19,
			paddingLeft:26,
		},
		form:{
			paddingTop:21,
			paddingLeft:36,
			paddingRight:66,
			paddingBottom:30,
			alignItems:"center",
			// backgroundColor:"rgba(0, 0, 0, 0.26)"
		},
		addEditTicketTypeTitle:{
			flexDirection:"row", 
			display:"flex", 
			justifyContent:"space-between", 
			paddingRight:26}
	},
	table:{
		toolbar:{
			alignItems:"center",
			justifyContent:"space-between",
			marginBottom:5
		},
		container:{
			alignItems:"center",
			justifyContent:"center",
			height:"100%"
		},
		actionsColumn:{
			textAlign:"center",
		},
		row:{
			background:"#ffffff"
		},
		rowColor:{
			background:"#f9f9f9"
		},
		activeCell:{
			color:"#04aa86"
		},
		empty:{
			paddingTop:20,
			paddingLeft:20
		}
	},
	footer:{
		toolbar:{
			justifyContent:"flex-end"
		},
		button:{
			marginLeft:20
		}
	},
	imageSelector:{ 
		width: 253, 
		height: 109, 
		backgroundColor:"#e9e9e9",
		backgroundSize:"contain", 
		backgroundRepeat:"no-repeat", 
		backgroundPosition:"center"
	},
	stats:{
		tktToSell:{
			paper:{
				padding:10
			},
			label:{
				fontSize:14,
				color:"#5a5956",
				letterSpacing:0.2
			},
			value:{
				fontSize:19,
				color:"#5a5956",
				fontWeight:"bold"
			}
		},
		tktSellRRPP:{
			paper:{
				padding:10
			},
			label:{
				fontSize:14,
				color:"#5b95bb",
				letterSpacing:0.2
			},
			value:{
				fontSize:19,
				color:"#5b95bb",
				fontWeight:"bold"
			}
		},
		tktSellNoRRPP:{
			paper:{
				padding:10
			},
			label:{
				fontSize:14,
				color:"#5a5956",
				letterSpacing:0.2
			},
			value:{
				fontSize:19,
				color:"#5a5956",
				fontWeight:"bold"
			}
		},
		tktSold:{
			paper:{
				padding:10
			},
			label:{
				fontSize:14,
				color:"#03a900",
				letterSpacing:0.2
			},
			value:{
				fontSize:19,
				color:"#03a900",
				fontWeight:"bold"
			}
		},
		producer:{
			paper:{
				padding:10,
				backgroundColor:"#03a900"
			},
			label:{
				fontSize:14,
				color:"#ffffff",
				letterSpacing:0.2
			},
			value:{
				fontSize:19,
				color:"#ffffff",
				fontWeight:"bold"
			}
		},
		titleDetail:{
			box:{
				borderBottomStyle:"solid",
				borderBottomWidth:5,
				borderBottomColor:"#f02f66",
				marginTop: 30,
				padding:12
			},
			label:{
				fontSize:14,
				color:"#f02f66",
				fontWeight:"400",
				letterSpacing:0.5
			}
		}
	},
	StatsCard:{
		container:{
			height:"100%",
			width:"49%",
			marginTop:33,
		},
		header:{
			container:{
				justifyContent:"space-between",
				alignContent:"center",
				paddingLeft:24,
				paddingRight:18,
				height:30,
				borderTopLeftRadius:4,
				borderTopRightRadius:4
			},
			label:{
				fontSize:13,
				fontWeight:"lighter"
			},
			value:{
				textAlign:"right",
				fontSize:13,
			}
		},
		label:{
			fontSize:14,
			color:"#5a5956",
			letterSpacing:0.2,
			fontWeight:"lighter"

		},
		value:{
			textAlign:"right",
			fontSize:14,
			color:"#5a5956",
			letterSpacing:0.2,
			fontWeight:"bolder",

		},
		row:{
			justifyContent:"space-between",
			paddingLeft:24,
			paddingRight:24,
			borderBottom: "rgba(0, 0, 0, 0.23)",
    	borderBottomStyle: "solid",
			borderBottomWidth: "thin",
			height:43
		},

		footer:{
			container:{
				backgroundColor:"green",
				paddingLeft:14,
				paddingRight:14,
				height:43,
				borderBottomLeftRadius:4,
				borderBottomRightRadius:4
			},
			label:{
				fontSize:13,
				color:"#ffffff",
				fontWeight:"lighter"
			},
			value:{
				textAlign:"right",
				fontSize:13,
				color:"#ffffff"
			}
			
		}
	},
	addEditRestaurant:{
		row:{
			background:"#ffffff"
		},
		rowColor:{
			background:"#f9f9f9"
		},
		cell:{
			padding:0
		}
	},
	orders:{
		selectView:{
			minWidth:160,
			color:"rgb(0,0,0,0.87)",
			fontSize:13
		}
	},
	gridTotal:{
		header:{
			borderBottomStyle:"solid",
			borderBottomColor:"#ccc",
			borderBottomWidth:2,
			// // margin:0,
			// paddingTop:0
		},
		titleColumn:{
			// borderRightStyle:"solid",
			// borderRightColor:"#000",
			// borderRightWidth:10,
			// // margin:0,
			// padding:12
		},
		totalRow:{
			borderTopStyle:"solid",
			borderTopColor:"#ccc",
			borderTopWidth:1,
			// // margin:0,
			// paddingTop:0
		},
		totalColumn:{
			// borderLeftStyle:"solid",
			// borderLeftColor:"#000",
			// borderLeftWidth:10,
			// // margin:0,
			// padding:12,
			
		},
		totalText:{
			fontWeight:"bold"
		}
	}
	/*
	badge: {
		secondaryColor: "#3B3C3C"
	},
	button: {
		height: 30,
		minWidth: 40
	},
	checkbox: {
		boxColor: "#70787d",
		labelColor: "#70787d",
		fontSize: 12
	},
	card: {
		titleColor: "#1BB6B1"
	},
	datePicker: {
		selectColor: "#3B3C3C",
		headerColor: "#1BB6B1"
	},
	dialog: {
		titleFontSize: 18,
		bodyFontSize: 13
	},
	flatButton: {
		fontSize: 12
	},
	floatingActionButton: {
		buttonSize: 35,
		miniSize: 25,
		color: "#1BB6B1"
	},
	menuItem: {
		dataHeight: 5,
		height: 30,
		padding: 0,
		fontSize: 10,
		selectedTextColor: "#002E74",
		rightIconDesktopFill: "#ff0000",
		spacing: 5
	},
	raisedButton: {
		fontSize: 12,
		height: 20,
		primaryColor: "#5d9ac2",//"#1BB6B1",
		secondaryColor: "#C230A4"
	},
	tableHeader: {
		whiteSpace: "normal",
		borderSize: 2
	},
	tableHeaderColumn: {
		height: 10,
		spacing: 10,
		whiteSpace: "normal",
		fontSize: 10
	},
	tableRow: {
		stripeColor: "#F5F5F5",
		border: "1px solid #ccc",
		height: 40
	},
	tableRowColumn: {
		height: 25,
		spacing: 10
	},
	tableFooter: {
		borderColor: "#EB825D"
	},
	textField: {
    hintColor: "rgba(0, 0, 0, 0.3)",
    color: "#0091d4"
	},
	timePicker: {
		headerColor: "#1BB6B1"
	}
	*/
}

module.exports = Nuevamente


// WEBPACK FOOTER //
// ./src/config/Themes/Nuevamente.js